import React, { useCallback, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import { ClassroomManager } from '@helpers'
import { Classroom as ClassroomConstants } from '@constants'
import { useHideIntercomLauncher } from '@components/Classroom/hooks/useHideIntercomLauncher'

import Initializer from '../Classroom/components/Initializer'
import { Onboarding, Main } from './components'
import {
  useSketchpadState,
  SketchpadProvider,
  useSketchpadStateDispatch
} from './hooks'
import { useAuth } from '@hooks'
import { useClassroomQuery } from '@components/Classroom/hooks'
import { ClassroomPermissionsProvider } from '../Classroom/contexts'

const Sketchpad = () => {
  const { id: classroomId } = useParams()
  const { step } = useSketchpadState()
  const dispatch = useSketchpadStateDispatch()
  const { profile, token } = useAuth()

  const onPanelsChange = useCallback(
    () =>
      dispatch({
        type: 'set_panels',
        payload: ClassroomManager.getPanels()
      }),
    [dispatch]
  )

  useClassroomQuery({
    onSuccess: () => {
      dispatch({
        type: 'set_step',
        payload: ClassroomConstants.STEPS.ONBOARDING
      })

      ClassroomManager.init({
        id: classroomId || profile.id,
        user: profile,
        env: ClassroomConstants.ENV.SKETCHPAD,
        token
      })

      ClassroomManager.observe('panels', onPanelsChange)
    }
  })

  useEffect(() => {
    return () => {
      ClassroomManager.unobserve('panels', onPanelsChange)
      ClassroomManager.destroy()
    }
  }, [onPanelsChange])

  useHideIntercomLauncher(step)

  return (
    <div className='gp-new-classroom gp-Sketchpad'>
      <Helmet>
        <meta name='theme-color' content='#1a1b1e' data-react-helmet='true' />
      </Helmet>

      {step === ClassroomConstants.STEPS.FETCHING && <Initializer />}

      {step === ClassroomConstants.STEPS.ONBOARDING && <Onboarding />}

      {step === ClassroomConstants.STEPS.READY && <Main />}

      {/* {step === ClassroomConstants.STEPS.READY && (
        <Footer withControls={step === ClassroomConstants.STEPS.READY} />
      )} */}
    </div>
  )
}

const SketchpadWrapper = () => {
  return (
    <SketchpadProvider>
      <ClassroomPermissionsProvider>
        <Sketchpad />
      </ClassroomPermissionsProvider>
    </SketchpadProvider>
  )
}

export default SketchpadWrapper
